import alwGraphIntrospection from './fragmentTypes.json';
import ragIntrospection from './ragIntrospection.json';

// Stolen shamelessly from https://www.apollographql.com/docs/react/data/fragments/#generating-possibletypes-automatically
function generatePossibleTypes(isZgGraph) {
  const possibleTypes = {};
  const resultData = isZgGraph ? ragIntrospection : alwGraphIntrospection;
  resultData.__schema.types.forEach((supertype) => {
    if (supertype.possibleTypes) {
      possibleTypes[supertype.name] = supertype.possibleTypes.map((subtype) => subtype.name);
    }
  });
  return possibleTypes;
}

export default generatePossibleTypes;
